import { Box, Tab } from '@mui/material';
import { Tabs } from '@components/tabs';
import { Dispatch, SetStateAction, SyntheticEvent, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '@store/GlobalStore';
import { QuoteGetResponse } from '@lio/api-types';
import { QuoteStatus } from '@models/quotes';
import { shallow } from 'zustand/shallow';

type SummaryTabsProps = {
  activeTab: SummaryTab;
  onActiveTabChange: Dispatch<SetStateAction<SummaryTab>>;
  quote: QuoteGetResponse;
};

export enum SummaryTab {
  Details = 'details',
  Activity = 'quoteActivity',
}

export const SummaryTabs = (props: SummaryTabsProps) => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { isInternalUser } = useStore((state) => state.userAuth, shallow);
  const { activeTab, onActiveTabChange, quote } = props;
  const isReadOnly = search.toLowerCase().includes('viewreadonly');

  const tabValues = useMemo(() => {
    return {
      [SummaryTab.Details]: {
        label: 'Details',
        urlPath: `${
          isReadOnly || (!isInternalUser && quote.status.id === QuoteStatus.Referred.id) ? '?viewReadOnly=true&' : '?'
        }sidebarItem=summary&sidebarTab=details`,
      },
      [SummaryTab.Activity]: {
        label: 'Quote Activity',
        urlPath: `${
          isReadOnly || (!isInternalUser && quote.status.id === QuoteStatus.Referred.id) ? '?viewReadOnly=true&' : '?'
        }sidebarItem=summary&sidebarTab=activities`,
      },
    };
  }, [isInternalUser, isReadOnly, quote.status.id]);

  const handleChange = (event: SyntheticEvent, selectedTab: SummaryTab) => {
    onActiveTabChange(selectedTab);
    navigate(tabValues[selectedTab].urlPath, { replace: false });
  };

  return (
    <Box>
      <Tabs value={activeTab} type='mini' onChange={handleChange}>
        <Tab label={tabValues[SummaryTab.Details].label} value={SummaryTab.Details} tabIndex={0} />
        <Tab label={tabValues[SummaryTab.Activity].label} value={SummaryTab.Activity} tabIndex={0} />
      </Tabs>
    </Box>
  );
};
